import brotliWasm from 'brotli-wasm';

const base64UrlEncode = (input: Uint8Array): string => {
  const base64 = btoa(String.fromCharCode(...input));
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

export const generateCompressedLink = async (
  data: object | string
): Promise<string> => {
  const json = typeof data === 'string' ? data : JSON.stringify(data);
  const jsonBytes = new TextEncoder().encode(json);

  const { compress } = await brotliWasm;
  const compressed = compress(jsonBytes);

  return base64UrlEncode(compressed);
};
